import { ShowMessageActivity } from './ShowMessageActivity.js'
import { OpenPageActivity } from './OpenPageActivity.js'
import { ClosePageActivity } from './ClosePageActivity.js'

export const activities = {
  ShowMessageActivity,
  OpenPageActivity,
  ClosePageActivity
}
  